import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.5 } },
  exit: { opacity: 0, transition: { duration: 0.3 } },
};

export default function Datenschutz() {
  return (
    <motion.main
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      data-testid="datenschutz-page"
    >
      <div className="pt-32 pb-24 px-6 md:px-12 max-w-3xl mx-auto">
        <p
          className="text-[#C1440E] text-xs tracking-[0.4em] uppercase mb-4"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Rechtliches
        </p>
        <h1
          className="text-5xl md:text-6xl font-extrabold uppercase text-[#F2EDE8] mb-12"
          style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
        >
          Datenschutz
        </h1>

        <div className="space-y-8" style={{ fontFamily: "'Outfit', sans-serif" }}>
          <section>
            <h2 className="text-lg font-semibold text-[#F2EDE8] mb-3">
              1. Datenschutz auf einen Blick
            </h2>
            <p className="text-[#A19D98] text-sm leading-relaxed">
              Wenn Sie unsere Website besuchen, können verschiedene personenbezogene Daten
              erhoben werden. Personenbezogene Daten sind Daten, mit denen Sie persönlich
              identifiziert werden können. Diese Datenschutzerklärung erläutert, welche Daten
              wir erheben und wofür wir sie nutzen.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-[#F2EDE8] mb-3">
              2. Verantwortlicher
            </h2>
            <p className="text-[#A19D98] text-sm leading-relaxed">
              Klaus Teichmann<br />
              Schattbachstraße 77, 44803 Bochum<br />
              Telefon: 0234 / 935 000 2<br />
              E-Mail: info@bochum-partyraum.de
            </p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-[#F2EDE8] mb-3">
              3. Kontaktformular
            </h2>
            <p className="text-[#A19D98] text-sm leading-relaxed">
              Das Kontaktformular auf dieser Website befindet sich im Demo-Modus. Es werden
              keine Daten an einen Server übertragen oder gespeichert. Für eine verbindliche
              Anfrage wenden Sie sich bitte direkt per Telefon oder E-Mail an uns.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-[#F2EDE8] mb-3">4. Google Maps</h2>
            <p className="text-[#A19D98] text-sm leading-relaxed">
              Diese Website verwendet Google Maps. Anbieter ist die Google Ireland Limited,
              Gordon House, Barrow Street, Dublin 4, Irland. Zur Nutzung von Google Maps ist
              es notwendig, Ihre IP-Adresse zu speichern. Diese Informationen werden in der
              Regel an einen Server von Google in den USA übertragen und dort gespeichert. Der
              Anbieter dieser Seite hat keinen Einfluss auf diese Datenübertragung. Die Nutzung
              von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer
              Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs.
              1 lit. f DSGVO dar.
            </p>
          </section>
          <section>
            <h2 className="text-lg font-semibold text-[#F2EDE8] mb-3">5. Ihre Rechte</h2>
            <p className="text-[#A19D98] text-sm leading-relaxed">
              Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten
              personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der
              Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser
              Daten. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich
              jederzeit unter der im Impressum angegebenen Adresse an uns wenden.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-[#F2EDE8]/10">
          <Link
            to="/"
            className="text-[#C1440E] hover:text-[#D4A843] text-sm transition-colors"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            ← Zurück zur Startseite
          </Link>
        </div>
      </div>
    </motion.main>
  );
}
